<template>
  <div>
    <center>
      <v-card-title> See the map’s features: </v-card-title>
      <div :class="['introVideoWrapper', play ? 'play' : 'stop']">
        <div class="video_thumbnail introVideoWrapperAct">
          <img
            @click="play = !play"
            v-if="!play"
            class="introVideoAct"
            src="/intro/staticVideo.jpg"
          />
          <img
            @click="play = !play"
            v-if="play"
            class="introVideoAct"
            src="https://maptivate-cms-01.s3.ap-southeast-2.amazonaws.com/sites04/2/assets/introVideo.gif"
          />

          <video class="introVideoAct" v-if="false && play" autoplay>
            <source
              src="https://maptivate-cms-01.s3.ap-southeast-2.amazonaws.com/sites04/2/assets/introVideo.mp4"
              type="video/mp4"
            />
          </video>

          <div class="play-btn">
            <v-btn
              title="Play"
              color="primary"
              depressed
              fab
              xicon
              xoutlined
              xplain
              rounded
              large
              @click="play = !play"
            >
              <v-icon x-large v-if="!play">mdi-play</v-icon>
              <v-icon x-large v-if="play">mdi-stop</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </center>
  </div>
</template>

<script>
export default {
  name: "introVideo",
  props: {},
  components: {},
  data: () => ({
    play: false
  }),
  watch: {},
  computed: {},
  methods: {
    //do nothing
  }
};
</script>
<style>
.video_thumbnail {
  border: 1px solid grey;
  border-radius: 5px;
  position: relative;
}

.video_thumbnail:hover {
  cursor: pointer;
}

.video_thumbnail .play-btn {
  display: inline-block;
  padding: 25px;
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.video_thumbnail .play-btn {
  transition: top 0.5s;
}

.play .video_thumbnail .play-btn {
  top: 94%;
}

.stop .video_thumbnail .play-btn {
  top: 70%;
}

.introVideoAct {
  max-height: calc(100vh - 240px);
  max-width: 90%;
}

.introVideoWrapperAct {
  max-height: calc(100vh - 230px);
  max-width: 90%;
}

@media only screen and (max-height: 780px) and (min-width: 1264px) {
  .introVideoAct {
    max-height: calc(100vh - 300px);
    max-width: 80%;
  }

  .introVideoWrapperAct {
    max-height: calc(100vh - 290px);
    max-width: 80%;
  }
}

@media only screen and (max-width: 1264px) {
  .introVideoAct {
    max-height: calc(100vh - 300px);
    max-width: 80%;
  }

  .introVideoWrapperAct {
    max-height: calc(100vh - 290px);
    max-width: 80%;
  }

  .play .video_thumbnail .play-btn {
    top: 100%;
  }
}
</style>
